import React from 'react';
import styleable from 'react-styleable';
import PropTypes from 'prop-types';
import { DataTable } from '@3plearning/react-components';
import css from './report-table.scss';

/**
 * ReportTable pro-forma template for stateless component
 * Displays heading, subheading & table with footer
 */
const ReportTable = ({ heading, subHeading, tableConfig, tableData, tableFooterData }) => (
    <div className={css.component}>
        <h3>{heading}</h3>
        <p className={css['sub-heading']}>{subHeading}</p>
        <DataTable
            className={css['data-table']}
            config={tableConfig}
            data={tableData}
            footerData={tableFooterData}
        />
    </div>
);

ReportTable.propTypes = {
    heading: PropTypes.string,
    subHeading: PropTypes.string,
    tableConfig: PropTypes.object,
    tableData: PropTypes.array,
    tableFooterData: PropTypes.object
};

export default styleable(css)(ReportTable);



// WEBPACK FOOTER //
// ./components/report-table/report-table.js